export const translateCampaignCollection = campaigns => {
    const googleCampaigns = campaigns.googleCampaignsList.map(campaign => ({...campaign, channel: 'google'}));
    const facebookCampaigns = campaigns.facebookCampaignsList.map(campaign => ({...campaign, channel: 'facebook'}));

    return googleCampaigns.concat(facebookCampaigns);
};